module.exports = __webpack_public_path__ + "assets/img/home_top_btn.9dd472eb.png";